
import { defineComponent } from 'vue';
import HeaderBar from '@/components/HeaderBar.vue';
import NavigationSidebar from '@/components/NavigationSidebar.vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'App',

  components: {
    HeaderBar,
    NavigationSidebar
  },
  computed: {
    ...mapGetters([
      'isLoggedIn'
    ])
  },
  created() {
    const userToken = localStorage.getItem('userToken')
    if (userToken) {
      const userData = JSON.parse(userToken)
      this.$store.commit('setUserData', userData)
    }
  },
});
